import { render } from "./LaptopAnimation.vue?vue&type=template&id=66a2e2ce&scoped=true"
import script from "./LaptopAnimation.vue?vue&type=script&lang=js"
export * from "./LaptopAnimation.vue?vue&type=script&lang=js"

import "./LaptopAnimation.vue?vue&type=style&index=0&id=66a2e2ce&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a2e2ce"]])

export default __exports__